import { Helmet } from "react-helmet";
import EventDetails from "../../components/EventDetails";
import EventsListSection from "./EventsListSection";
import React, { Suspense } from "react";
import { TabPanel, Tabs } from "react-tabs";

const upcomingEventsGrid = [
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
  {
    eventDate: (
      <>
        10
        <br />
        JAN
      </>
    ),
    eventButtonLabel: "workshop",
    eventTitle:
      "The 3 Most Impactful Food Cost Controls for Independent Restaurants",
    eventLocation: "Cairo, Egypt",
    attendeesCount: "+20 Going",
    eventPrice: "200 EGP",
  },
];

export default function EventsListPage() {
  return (
    <>
      <Helmet>
        <title>Upcoming Events - Workshops & Networking for Restaurants</title>
        <meta
          name="description"
          content="Explore our list of events tailored for the restaurant industry, including workshops on food cost controls and networking opportunities in Cairo, Egypt. Join the community and grow your business."
        />
      </Helmet>
      <div className="w-full overflow-x-scroll bg-gray-50 py-[46px] md:py-5 sm:py-4">
        <Tabs
          className="mb-[258px] flex w-full flex-col items-center gap-[18px]"
          selectedTabClassName=""
          selectedTabPanelClassName="mr-5 md:mr-0 !relative tab-panel--selected"
        >
          {/* events list section */}
          <EventsListSection />
          <div className="container-sm lg:px-5 md:px-5">
            {[...Array(5)].map((_, index) => (
              <TabPanel
                key={`tab-panel${index}`}
                className="absolute mr-5 justify-center md:mr-0"
              >
                <div className="w-full">
                  <div className="grid grid-cols-4 gap-2.5 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
                    <Suspense fallback={<div>Loading feed...</div>}>
                      {upcomingEventsGrid.map((d, index) => (
                        <EventDetails {...d} key={"grid10JanOne" + index} />
                      ))}
                    </Suspense>
                  </div>
                </div>
              </TabPanel>
            ))}
          </div>
        </Tabs>
      </div>
    </>
  );
}
